/*!
 * Vue Highlight.js v0.0.1
 * (c) 2017 Saran Tanpituckpong
 * Released under the MIT License
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("highlight.js"));
	else if(typeof define === 'function' && define.amd)
		define("VueHighlightJS", ["highlight.js"], factory);
	else if(typeof exports === 'object')
		exports["VueHighlightJS"] = factory(require("highlight.js"));
	else
		root["VueHighlightJS"] = factory(root["hljs"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 4);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__escape__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getSlotText__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__indentCode__ = __webpack_require__(9);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__escape__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__getSlotText__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__indentCode__["a"]; });






/***/ }),
/* 3 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HighlightCode__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HighlightCodes__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__languages__ = __webpack_require__(16);





/**
 * Install Vue Highlight.js as plugin.
 *
 * @param {Vue} Vue
 */
function install(Vue) {
  Vue.component('highlight-code', __WEBPACK_IMPORTED_MODULE_0__HighlightCode__["a" /* default */]);
  Vue.component('highlight-codes', __WEBPACK_IMPORTED_MODULE_1__HighlightCodes__["a" /* default */]);
}

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

/* harmony default export */ __webpack_exports__["default"] = ({
  install: install
});

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HighlightCode_vue__ = __webpack_require__(6);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HighlightCode_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_highlight_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_highlight_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_highlight_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_code_pre_css__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_code_pre_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_code_pre_css__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }







/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'highlight-code',
	props: {
		lang: String,
		inline: {
			type: Boolean,
			default: false
		},
		code: String,
		auto: Boolean,
		ln: {
			type: Boolean,
			default: true
		}
	},
	data: function data() {
		return {
			inlineStyles: {
				'display': 'inline !important',
				'vertical-align': 'middle'
			}
		};
	},

	computed: {
		hasCode: function hasCode() {
			return typeof this.code === 'string' && this.code.length > 0;
		}
	},
	render: function render(createElement) {
		var hasCode = this.hasCode;
		var lang = this.lang;
		var inline = this.inline;
		var code = hasCode ? this.code : Object(__WEBPACK_IMPORTED_MODULE_1__lib__["b" /* getSlotText */])(this.$slots.default); // If no `code`, get text from default slot.
		var auto = this.auto;
		var ln = this.ln;
		code = !inline ? Object(__WEBPACK_IMPORTED_MODULE_1__lib__["c" /* indentCode */])(code) : code; // Don't indent code if in inline mode.
		var highlightedCode = void 0,
		    codeLine = '';
		if (auto) {
			var _hljs$highlightAuto = __WEBPACK_IMPORTED_MODULE_0_highlight_js__["highlightAuto"](code);

			lang = _hljs$highlightAuto.language;
			highlightedCode = _hljs$highlightAuto.value;
		} else {
			highlightedCode = lang ? __WEBPACK_IMPORTED_MODULE_0_highlight_js__["highlight"](lang, code).value : Object(__WEBPACK_IMPORTED_MODULE_1__lib__["a" /* escape */])(code); // If no `lang`, just display plain code.
		}
		if (ln) {
			codeLine = highlightedCode.split('\n').map(function (val, index) {
				return '<li class="code-pre-item">' + index + '</li>';
			}).join('');
		}
		return createElement(!inline ? 'pre' : 'span', {
			'class': ['code-container']
		}, [ln && createElement('ul', {
			'class': ['code-pre'],
			domProps: {
				innerHTML: codeLine
			}
		}), createElement('code', {
			'class': ['hljs', 'code-box'].concat(_toConsumableArray(lang ? [lang] : [])),
			style: inline ? this.inlineStyles : {},
			domProps: {
				innerHTML: highlightedCode
			}
		})]);
	}
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = escape;
/**
 * Escape code.
 *
 * @export
 * @param {string} code Code.
 * @returns {string}
 */
function escape(code) {
	if (typeof code === 'string') {
		return code.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&apos;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
	} else {
		return code;
	}
}

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getSlotText;
/**
 * Deeply get concatenated text from slot.
 *
 * @export
 * @param {VNode[]} slot A slot. (The collection of VNode)
 * @returns {string}
 */
function getSlotText(slot) {
	if (Array.isArray(slot)) {
		return slot.map(function (node) {
			// node is VNode
			if (Array.isArray(node.children) && node.children.length > 0) {
				return getSlotText(node.children);
			} else {
				return node.text;
			}
		}).join('');
	} else {
		return '';
	}
}

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = indentCode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_detect_indent__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_detect_indent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_detect_indent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redent__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redent__);



/**
 * Indent code.
 *
 * @export
 * @param {string} code Code.
 * @returns {string}
 */
function indentCode(code) {
	if (typeof code === 'string') {
		var indent = __WEBPACK_IMPORTED_MODULE_0_detect_indent__(code).indent || '\t';
		code = __WEBPACK_IMPORTED_MODULE_1_redent__(code, 0, indent);
		return code.trim();
	} else {
		return code;
	}
}

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// detect either spaces or tabs but not both to properly handle tabs
// for indentation and spaces for alignment

var INDENT_RE = /^(?:( )+|\t+)/;

function getMostUsed(indents) {
	var result = 0;
	var maxUsed = 0;
	var maxWeight = 0;

	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = indents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var entry = _step.value;

			// TODO: use destructuring when targeting Node.js 6
			var key = entry[0];
			var val = entry[1];

			var u = val[0];
			var w = val[1];

			if (u > maxUsed || u === maxUsed && w > maxWeight) {
				maxUsed = u;
				maxWeight = w;
				result = Number(key);
			}
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}

	return result;
}

module.exports = function (str) {
	if (typeof str !== 'string') {
		throw new TypeError('Expected a string');
	}

	// used to see if tabs or spaces are the most used
	var tabs = 0;
	var spaces = 0;

	// remember the size of previous line's indentation
	var prev = 0;

	// remember how many indents/unindents as occurred for a given size
	// and how much lines follow a given indentation
	//
	// indents = {
	//    3: [1, 0],
	//    4: [1, 5],
	//    5: [1, 0],
	//   12: [1, 0],
	// }
	var indents = new Map();

	// pointer to the array of last used indent
	var current = void 0;

	// whether the last action was an indent (opposed to an unindent)
	var isIndent = void 0;

	var _iteratorNormalCompletion2 = true;
	var _didIteratorError2 = false;
	var _iteratorError2 = undefined;

	try {
		for (var _iterator2 = str.split(/\n/g)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
			var line = _step2.value;

			if (!line) {
				// ignore empty lines
				continue;
			}

			var _indent = void 0;
			var matches = line.match(INDENT_RE);

			if (matches) {
				_indent = matches[0].length;

				if (matches[1]) {
					spaces++;
				} else {
					tabs++;
				}
			} else {
				_indent = 0;
			}

			var diff = _indent - prev;
			prev = _indent;

			if (diff) {
				// an indent or unindent has been detected

				isIndent = diff > 0;

				current = indents.get(isIndent ? diff : -diff);

				if (current) {
					current[0]++;
				} else {
					current = [1, 0];
					indents.set(diff, current);
				}
			} else if (current) {
				// if the last action was an indent, increment the weight
				current[1] += Number(isIndent);
			}
		}
	} catch (err) {
		_didIteratorError2 = true;
		_iteratorError2 = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion2 && _iterator2.return) {
				_iterator2.return();
			}
		} finally {
			if (_didIteratorError2) {
				throw _iteratorError2;
			}
		}
	}

	var amount = getMostUsed(indents);

	var type = void 0;
	var indent = void 0;
	if (!amount) {
		type = null;
		indent = '';
	} else if (spaces >= tabs) {
		type = 'space';
		indent = ' '.repeat(amount);
	} else {
		type = 'tab';
		indent = '\t'.repeat(amount);
	}

	return {
		amount: amount,
		type: type,
		indent: indent
	};
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var stripIndent = __webpack_require__(12);
var indentString = __webpack_require__(13);

module.exports = function (str, count, indent) {
  return indentString(stripIndent(str), count || 0, indent);
};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (str) {
	var match = str.match(/^[ \t]*(?=\S)/gm);

	if (!match) {
		return str;
	}

	// TODO: use spread operator when targeting Node.js 6
	var indent = Math.min.apply(Math, match.map(function (x) {
		return x.length;
	})); // eslint-disable-line
	var re = new RegExp('^[ \\t]{' + indent + '}', 'gm');

	return indent > 0 ? str.replace(re, '') : str;
};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports = function (str, count, opts) {
	// Support older versions: use the third parameter as options.indent
	// TODO: Remove the workaround in the next major version
	var options = (typeof opts === 'undefined' ? 'undefined' : _typeof(opts)) === 'object' ? Object.assign({ indent: ' ' }, opts) : { indent: opts || ' ' };
	count = count === undefined ? 1 : count;

	if (typeof str !== 'string') {
		throw new TypeError('Expected `input` to be a `string`, got `' + (typeof str === 'undefined' ? 'undefined' : _typeof(str)) + '`');
	}

	if (typeof count !== 'number') {
		throw new TypeError('Expected `count` to be a `number`, got `' + (typeof count === 'undefined' ? 'undefined' : _typeof(count)) + '`');
	}

	if (typeof options.indent !== 'string') {
		throw new TypeError('Expected `options.indent` to be a `string`, got `' + _typeof(options.indent) + '`');
	}

	if (count === 0) {
		return str;
	}

	var regex = options.includeEmptyLines ? /^/mg : /^(?!\s*$)/mg;
	return str.replace(regex, options.indent.repeat(count));
};

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HighlightCodes_vue__ = __webpack_require__(15);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HighlightCodes_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_highlight_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_highlight_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_highlight_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_code_pre_css__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_code_pre_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_code_pre_css__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }







/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'highlight-code',
	props: {
		lang: String,
		inline: {
			type: Boolean,
			default: false
		},
		code: Array,
		auto: Boolean,
		ln: {
			type: Boolean,
			default: true
		},
		start: {
			type: Number,
			default: 0
		},
		remark: {
			type: Array,
			default: []
		}
	},
	data: function data() {
		return {};
	},

	computed: {
		hasCode: function hasCode() {
			return Array.isArray(this.code) && this.code.length > 0;
		}
	},
	render: function render(createElement) {
		var _this = this;

		var hasCode = this.hasCode;
		var lang = this.lang;
		var inline = this.inline;
		var code = hasCode ? this.code : []; // If no `code`, get text from default slot.
		var auto = this.auto;
		var ln = this.ln;
		var highlightedCode = void 0,
		    codeLines = [];
		highlightedCode = code.map(function (str, index) {
			var codeOneLine = '';
			if (auto) {
				var _hljs$highlightAuto = __WEBPACK_IMPORTED_MODULE_0_highlight_js__["highlightAuto"](str);

				lang = _hljs$highlightAuto.language;
				codeOneLine = _hljs$highlightAuto.value;
			} else {
				codeOneLine = lang ? __WEBPACK_IMPORTED_MODULE_0_highlight_js__["highlight"](lang, str).value : Object(__WEBPACK_IMPORTED_MODULE_1__lib__["a" /* escape */])(str); // If no `lang`, just display plain code.
			}
			console.log(_this.remark.indexOf(_this.start + index) > -1);
			codeLines.push('<li class="code-pre-item">' + (_this.start + index) + '</li>');
			return codeOneLine ? '<li class="code-li ' + (_this.remark.indexOf(_this.start + index) > -1 ? 'code-remark' : 'code-no-remark') + '"><code class="hljs ' + lang + '">' + codeOneLine + '</code></li>' : '';
		}).join('');
		return createElement('pre', {
			'class': ['code-container']
		}, [ln && createElement('ul', {
			'class': ['codes-pre'],
			domProps: {
				innerHTML: codeLines.join('')
			}
		}), createElement('ul', {
			'class': ['code-ul'].concat(_toConsumableArray(lang ? [lang] : [])),
			domProps: {
				innerHTML: highlightedCode
			}
		})]);
	}
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_highlight_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_highlight_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_highlight_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue__ = __webpack_require__(17);




__WEBPACK_IMPORTED_MODULE_0_highlight_js__["registerLanguage"]('vue', __WEBPACK_IMPORTED_MODULE_1__vue__["a" /* default */]);

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_highlight_js__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_highlight_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_highlight_js__);


/* harmony default export */ __webpack_exports__["a"] = (function () {
	return __WEBPACK_IMPORTED_MODULE_0_highlight_js__["getLanguage"]('xml');
});

/***/ })
/******/ ])["default"];
});


// WEBPACK FOOTER //
// vue-highlight.min.js